$(document).ready(function() {
  const homepageSwiper = new Swiper('.homepage-swiper', {
      effect: "creative",
      direction: "vertical",
      creativeEffect: {
        prev: {
          shadow: false,
          translate: ["0%", 0, -1],
        },
        next: {
          translate: [0, "100%", 0],
        },
      },
      mousewheel: {
        sensitivity: 0.1, 
        thresholdDelta: 20,
        thresholdTime: 10,
        forceToAxis: false,
        releaseOnEdges: true,
      },
      on: {
        slideChange: function () {
          checkActiveSlide();
        }
      }
  });

  function checkActiveSlide() {
    const activeSlide = homepageSwiper.slides[homepageSwiper.activeIndex];
    if ($(activeSlide).find('.color-white').length > 0) {
      $('body').addClass('white');
    } else {
      $('body').removeClass('white');
    }
  }
  checkActiveSlide();
});
